import { BrowserRouter as Router } from "react-router-dom";
import { useEffect, useState } from "react";
import AppRoutes from "./router/Routes";
import ScrollRestoration from "./router/ScrollRestoration";
import { CartWishlistProvider, HeaderProvider } from "./app/CartWishlistContext";
import MetaListener from "./app/MetaListener";
import useNetworkStatus from "./app/useNetworkStatus";

function AppContent() {
  const isOnline = useNetworkStatus();
  const [toast, setToast] = useState("");

  useEffect(() => {

    if (!isOnline) {
      document.body.style.filter = "grayscale(1)";
      document.body.style.pointerEvents = "none";
      document.body.style.userSelect = "none";
      document.body.style.cursor = "not-allowed";
      document.body.style.overflow = "hidden";

      // setToast("You Are Online");
    } else {
      document.body.style.filter = "none";
      document.body.style.pointerEvents = "auto";
      document.body.style.userSelect = "auto";
      document.body.style.cursor = "auto";
      document.body.style.overflow = "auto";
    }

    setTimeout(() => {
      setToast("");
    }, 3000);

  }, [isOnline]);

  return (
    <>
      <MetaListener />
      <ScrollRestoration />
      <AppRoutes />

      {toast && (
        <div style={{
          position: "fixed",
          bottom: "20px",
          left: "0%",
          transform: "translateX(-50%)",
          background: "green",
          padding: "6px 20px",
          borderRadius: "6px",
          zIndex: 9999,
          fontSize: "14px",
          width: "100%"
        }}>
          {toast}
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <HeaderProvider>
      <CartWishlistProvider>
        <Router>
          <AppContent />
        </Router>
      </CartWishlistProvider>
    </HeaderProvider>
  );
}
export default App;